import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalService } from '../../../services/modal/modal.service';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrl: './confirm-modal.component.scss',
    standalone: false
})
export class ConfirmModalComponent {
  @Input() title: string = '';
  @Input() text: string = '';
  @Input() buttonText: string = 'Очистить';

  @Output() clear = new EventEmitter<boolean>(false)

  constructor(private modalService: ModalService) {}

  closeModal() {
    this.modalService.closeModal();
  }

  delete() {
    this.clear.emit(true);
    this.closeModal();
  }

}
